import { useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import { CheckboxIcon } from '../../../../Icons';
import { canvasOptionsContext } from '../../../../context/canvasOptionsContext';
import { canvasModeContext } from '../../../../context/canvasModeContext';
import Tippy from '@tippyjs/react';
import 'tippy.js/animations/scale.css';
import { OptionNames, ModeNames } from '../../../../types/namesList';
import styles from './singleoption.module.css';
import { Box } from '@mui/material';
import { canvasHandFrameDataContext } from "../../../../context/canvasHandFrameDataContext";
import { canvasBackgroundContext } from "../../../../context/canvasBackgroundContext";

interface ISingleOptionProps {
    name: string;
    price: number;
    priceExtra: number;
    checked: boolean;
    indexKey: number;
    isPricePerMeter: boolean;
    isPercentToFullPrice: boolean;
    isPriceFromMaterial?: boolean;
    pricePropertyCode?: string;
    dataText: string;
    excluded: boolean;
    // hidden: boolean;
    minPrice?: number;
    minPriceText?: string;
    isExtraPrice?: boolean;
    isIndividualPrice?: boolean;
    // noMargin: boolean;
}

interface IOptionTooltipContentProps {
    content: string;
}

type ExtraOptionT = {
    name: string;
    price: number;
};

export function SingleOption(props: ISingleOptionProps) {
    const {
        name,
        price,
        priceExtra,
        checked,
        indexKey,
        isPricePerMeter,
        isPercentToFullPrice,
        isIndividualPrice,
        // isPriceFromMaterial,
        // pricePropertyCode,
        minPrice,
        minPriceText,
        dataText,
        excluded,
        // hidden,
        isExtraPrice,
        // noMargin
    } =
        props;

    const { options, setOptions } = useContext(canvasOptionsContext);
    const { backgroundData, setBackgroundData } = useContext(canvasBackgroundContext);
    const { mode, setMode, isSeamless, setIsSeamless, setIsSigned, setIsFlipped } = useContext(canvasModeContext);
    const [isChecked, setIsChecked] = useState(checked);
    // const [optionPrice, setOptionPrice] = useState(price);
    // const [checkedExtraOption, setCheckedExtraOption] = useState(0);
    const [checkedExtraOption, setCheckedExtraOption] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);

    const extraOptions: ExtraOptionT[] = [
        { name: 'A4', price: price },
        { name: '55x45 см', price: priceExtra },
    ];

    const { handFrameData } = useContext(canvasHandFrameDataContext),
        totalWidth = calcTotalWidth(handFrameData.width, handFrameData.height);

    const indexOptionStandartSizes = options?.items
        .findIndex(option => option.name === OptionNames.StandartSizes);

    const indexOptionNotStandartSizes = options?.items
        .findIndex(option => option.name === OptionNames.NotStandartSizes);

    function calcTotalWidth(width: number, height: number) {
        return Math.round((((Math.round(width) / 100) * Math.round(height)) / 100) * 10000) / 10000;
    }

    useEffect(() => {
        if(name === OptionNames.Install && minPrice) {
            const installPrice = totalWidth * price,
                disabled = installPrice < minPrice;

            setIsDisabled(disabled);

            if(disabled) {
                setIsChecked(false);
            }
        }

    }, [handFrameData]);

    // useEffect(() => { !!!!! НЕПОНЯТНО ЗАЧЕМ БЫЛО СДЕЛАНО
    //     if(options && !isSeamless && name === OptionNames.Varnish) {
    //         setIsDisabled(true);
    //         setIsChecked(false);
    //         options.items[indexKey].isSet = false;
    //     } else if(name !== OptionNames.Seamless) setIsDisabled(false);
    // }, [isSeamless]);

    useEffect(() => {
        setIsChecked(checked);
    }, [options]);


    useEffect(() => {
        // if(options && name === OptionNames.StandartSizes && mode === ModeNames.Handmode) {
        //     setIsChecked(true);
        //     options.items[indexKey].isSet = true;
        // }

        if(options && excluded) {

            if(name === OptionNames.StandartSizes) {
                setMode(ModeNames.Handmode);
                setIsDisabled(true);
            }

            if(name === OptionNames.NotStandartSizes && mode === ModeNames.Handmode) {
                setIsDisabled(true);
            }

            if(name === OptionNames.Signature) setIsSigned(false);

            setIsChecked(false);

            options.items[indexKey].isSet = false;
            // options.items[indexKey].isHidden = true;
        } else if(options && !excluded) {
            // options.items[indexKey].isHidden = false;
            if(name === OptionNames.StandartSizes) {
                setIsDisabled(false)
            }

            if(name === OptionNames.NotStandartSizes) {
                setIsDisabled(false);
            }
        }

        if(name === OptionNames.Seamless) {
            const currentBackgroundData = backgroundData.items.find(item => item.groupName === backgroundData.groupName);

            if(excluded) {
                if(!currentBackgroundData || currentBackgroundData && !currentBackgroundData.isSeamlessMode) setIsSeamless(false);
            }

            if(!excluded && currentBackgroundData && currentBackgroundData.isSeamlessMode) {
                setIsSeamless(true);
            }
            setIsDisabled(excluded);
        }

        if(options
            && indexOptionNotStandartSizes
            && options.items[indexOptionNotStandartSizes]
            && indexOptionStandartSizes
            && options.items[indexOptionStandartSizes]
            && excluded
            && name === OptionNames.StandartSizes) {
            options.items[indexOptionNotStandartSizes].isSet = true;
            options.items[indexOptionStandartSizes].isSet = false;
            setOptions({
                items: options.items,
            });
        }

        if(options
            && indexOptionNotStandartSizes
            && options.items[indexOptionNotStandartSizes]
            && indexOptionStandartSizes
            && options.items[indexOptionStandartSizes]
            && excluded
            && name === OptionNames.NotStandartSizes) {
            options.items[indexOptionNotStandartSizes].isSet = false;
            options.items[indexOptionStandartSizes].isSet = true;
            setOptions({
                items: options.items,
            });
        }

    }, [excluded]);

    const handleClick = () => {
        if(options && !excluded && !isDisabled) {
            const currentBackgroundData = backgroundData.items.find(item => item.groupName === backgroundData.groupName);

            if(name === OptionNames.NotStandartSizes) {
                setBackgroundData({
                    img: backgroundData.img,
                    backgroundColor: backgroundData.backgroundColor,
                    name: backgroundData.name,
                    price: backgroundData.price,
                    groupName: backgroundData.groupName,
                    isSeamless: backgroundData.isSeamless,
                    isSeamlessMode: false,
                    items: backgroundData.items,
                });
            }

            if(name === OptionNames.StandartSizes && currentBackgroundData) {
                if(currentBackgroundData.isSeamlessMode) {
                    setBackgroundData({
                        img: backgroundData.img,
                        backgroundColor: backgroundData.backgroundColor,
                        name: backgroundData.name,
                        price: backgroundData.price,
                        groupName: backgroundData.groupName,
                        isSeamless: true,
                        isSeamlessMode: true,
                        items: backgroundData.items,
                    });
                    setIsSeamless(true);
                }
            }
            if(name === OptionNames.Seamless) setIsSeamless(!isChecked);

            if(name === OptionNames.ShowJoints) setIsSeamless(isChecked);

            if(options
                && indexOptionNotStandartSizes
                && name === OptionNames.StandartSizes) {
                if(isChecked) return;
                setMode(isChecked ? ModeNames.Handmode : ModeNames.Panels);
                options.items[indexOptionNotStandartSizes].isSet = isChecked;
                setOptions({
                    items: options.items,
                });
            }

            if(options
                && indexOptionStandartSizes
                && name === OptionNames.NotStandartSizes) {
                if(isChecked) return;
                setMode(!isChecked ? ModeNames.Handmode : ModeNames.Panels);
                options.items[indexOptionStandartSizes].isSet = isChecked;
                setOptions({
                    items: options.items,
                });
            }

            if(name === OptionNames.Signature) setIsSigned(!isChecked);
            if(name === OptionNames.ToMirror) setIsFlipped(!isChecked);
            if(name === OptionNames.Example && isChecked) setCheckedExtraOption(0);

            setIsChecked(!isChecked);
            options.items[indexKey].isSet = !isChecked;
            setOptions({
                items: options.items,
            });
        }
    };

    const handleExtraOptionClick = (index: number, price: number) => {
        if(options && name === OptionNames.Example) {
            setCheckedExtraOption(index);
            options.items[indexKey].isExtraPrice = price === priceExtra;

            setOptions({
                items: options.items,
            });
        }
    };

    if(options && name === OptionNames.Example) {
        if(!price && priceExtra) options.items[indexKey].isExtraPrice = true;
    }

    return (
        <Box>
            <Tippy
                className={styles.info}
                content={<OptionTooltipContent content={dataText}/>}
                interactive={true}
                interactiveBorder={20}
                delay={100}
                duration={100}
                animation={'scale'}
                allowHTML={true}
                disabled={!isDisabled}
            >
                <div className={classNames(styles.container, isDisabled && styles.disabled)}>
                    <div className={classNames('row', 'w-100', 'row-space-between')}>
                        <div className={classNames(styles.singleOptionRow) + ' row'}>
                            <div className={styles.iconContainer} onClick={handleClick}>
                                <CheckboxIcon checked={isChecked}/>
                            </div>
                            <div className="row">
                                <div
                                    className={classNames(styles.nameContainer, isChecked ? 'js-selected-option' : '')}>
                                    {name}
                                </div>
                                <Tippy
                                    className={styles.info}
                                    content={<OptionTooltipContent content={dataText}/>}
                                    interactive={true}
                                    interactiveBorder={20}
                                    delay={100}
                                    duration={100}
                                    animation={'scale'}
                                    allowHTML={true}
                                    disabled={isDisabled}
                                >
                                    <div className={styles.tooltipIco}>(?)</div>
                                </Tippy>
                            </div>
                        </div>
                        <div className={styles.priceContainer}>
                            {options && name === OptionNames.Example && price && priceExtra ? 'от ' : ''}
                            {price ? price : priceExtra ? priceExtra : !isIndividualPrice ? 0 : ''} {isPricePerMeter
                            ? 'р./м2'
                            : isPercentToFullPrice
                                ? '% к цене заказа'
                                : isIndividualPrice
                                    ? 'Индивидуальная цена'
                                    : 'р.'
                            }
                        </div>
                    </div>
                    {minPrice && minPriceText && (
                        <div className={styles.minPriceTextContainer}>{minPriceText}</div>
                    )}
                </div>
            </Tippy>
            {options && name === OptionNames.Example && isChecked && (
                <div className={styles.extraOptions}>
                    {extraOptions.map((option, index) => (
                        option.price &&
                        <div key={index} className=
                            {`${option.name === '55x45 см' ? 'js-example-big' : 'js-example-small'} ${option.name === '55x45 см' && isExtraPrice ? 'selected' : ''} ${styles.extraContainer} row`}>
                            <div className={classNames(styles.singleOptionRow) + ' row'}>
                                <div
                                    className={classNames(styles.iconContainer, styles.iconContainerSmall)}
                                    onClick={() => handleExtraOptionClick(index, option.price)}
                                >
                                    <div
                                        className={classNames(styles.checkmark,
                                            isExtraPrice && index && styles.checkmarkChecked,
                                            !isExtraPrice && !index && styles.checkmarkChecked
                                        )}/>
                                </div>
                                <div className={styles.nameContainer}>{option.name}</div>
                            </div>
                            <div className={styles.priceContainer}>
                                {option.price} {isPricePerMeter
                                ? 'р./м2'
                                : isPercentToFullPrice
                                    ? '% к цене заказа'
                                    : 'р.'}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Box>
    );
}

const OptionTooltipContent = ({ content }: IOptionTooltipContentProps) => {
    return <div className={styles.tooltipContent} dangerouslySetInnerHTML={{ __html: content }}/>;
};
